/**
 * @desc 扫描盘点单号获取待执行盘点任务
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inventoryMaster.taskList.Params, options?: any) {
  return updateResponse(
    http(URL + `/inventoryMaster/taskListByIcno`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
